import { FC } from 'react';

export type ReadonlyFieldProps = {
  label: string;
  value: string | number | boolean | undefined;
};

export const LabelAndValue: FC<ReadonlyFieldProps> = ({ label, value }) => (
  <div className="w-full max-w-md">
    {/* TODO: can we use label here? */}
    <div className="h-6 text-sm/6 font-medium">{label}</div>
    <div className="mt-2 w-full text-sm/6 font-normal text-black">{value}</div>
  </div>
);
